// extracted by mini-css-extract-plugin
module.exports = {"image-grid":"building_image-grid__m4bmY","image-item":"building_image-item__eAFZL"};